import { createContext, useContext } from "react";

/**
 * Abre el modal **Registrar venta** desde la navegación inferior.
 * El flujo por pasos (carrusel / wizard) y la pantalla de **resumen antes de enviar**
 * viven en `home/VentaComprobanteModal.tsx`.
 */
export const VentaModalContext = createContext<() => void>(() => {
  // no-op; provider en UsuarioHome
});

export const useVentaModal = () => useContext(VentaModalContext);
